import PlacesAutocomplete from './PlacesAutocomplete';
import {
  geocodeByAddress,
  geocodeByPlaceId,
  getLatLng,
  getAddressObject,
} from './utils';

export {
  geocodeByAddress,
  geocodeByPlaceId,
  getLatLng,
  getAddressObject,
};

export default PlacesAutocomplete;



// WEBPACK FOOTER //
// ./src/components/AddressAutocomplete/index.js